import React from "react";
import {useNavigate} from "react-router-dom";
import {parseISO} from "date-fns";

import KeyValueHorizontal from "../../components/KeyValueHorizontal";
import SummaryCard, {SummaryCardActions, SummaryCardStack} from "./SummaryCard";
import {monthNameShortString} from "../../services/date/formatters";

import blue from "@mui/material/colors/blue";
import DateRange from "@mui/icons-material/DateRange";
import {LineChart} from "@mui/x-charts";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";


const BookingsCard = (props) => {
    const {bookingsSummary} = props;
    const navigate = useNavigate();

    const data = bookingsSummary.monthlyOccupancy.map(p => p.occupancy);
    const xLabels = bookingsSummary.monthlyOccupancy.map(p => monthNameShortString(parseISO(p.month)));

    const chartsWidth = 260;
    const chartsHeight = 110;
    const maxValue = Math.max(...data) * 1.1;

    const handleTableauSelection = () => {
        navigate("/main/bookings?tab=tableau");
    }

    const handleArrivalsSelection = () => {
        navigate("/main/bookings?tab=arrivals");
    }

    const handleAvailabilitySelection = () => {
        navigate("/main/bookings?tab=availabilities");
    }

    const cardColor = blue[600];
    return <SummaryCard title="Prenotazioni"
                        avatarColor={cardColor}
                        AvatarIcon={DateRange}>

        <SummaryCardStack spacing={3}>
            <Typography variant="button" color="text.primary" fontSize="small" p="11px">Occupazione %</Typography>
            <LineChart
                margin={{top: 0, left: 35, right: 0, bottom: 25}}
                series={[
                    {data: data, area: true, color: cardColor},
                ]}
                xAxis={[{scaleType: 'band', data: xLabels}]}
                yAxis={[{scaleType: 'linear', min: 0, max: maxValue}]}
                width={chartsWidth}
                height={chartsHeight}
            />
            <KeyValueHorizontal valueTextVariant="h5"
                                keyTextVariant="body2"
                                showKeyOnBottom={true}
                                keyPadding={0}
                                pairs={[
                                    ["Arrivi (oggi)", bookingsSummary.todayArrivals],
                                    ["Partenze (oggi)", bookingsSummary.todayDepartures],
                                    ["Prenotazioni", bookingsSummary.futureBookings],
                                ]}
            />
        </SummaryCardStack>

        <SummaryCardActions>
            <Button size="small" onClick={handleTableauSelection}>Tableau</Button>
            <Button size="small" onClick={handleArrivalsSelection}>Arrivi</Button>
            <Button size="small" onClick={handleAvailabilitySelection}>Disponibilità</Button>
        </SummaryCardActions>
    </SummaryCard>
}


export default BookingsCard;